import { useSelector, useDispatch } from 'react-redux';
import { closeShareBetModal, selectIsOpen, selectIsLoading, selectBet } from './sportsbook-share-bet-modal-duck';
import ShareBetModal from './sportsbook-share-bet-modal';
import { AppDispatch } from '../../../../../store/types';
import { useTypedTranslations } from '../../../../translation/use-translations';
import ShareBetModalTextKeys from './sportsbook-share-bet-modal-text-keys';
import { useCallback, useRef } from 'react';
import useWebShareHtmlAsImage from '../../../../../hooks/use-web-share-html-as-image';

const ShareBetModalContainer = () => {
	const dispatch: AppDispatch = useDispatch();
	const isOpen = useSelector(selectIsOpen);
	const isLoading = useSelector(selectIsLoading);
	const bet = useSelector(selectBet);
	const { translations, isLoadingTranslations } = useTypedTranslations(ShareBetModalTextKeys);
	const cardRef = useRef<HTMLDivElement>(null);

	const handleShareCompleted = useCallback(() => dispatch(closeShareBetModal()), [dispatch]);
	const handleShareError = useCallback(() => dispatch(closeShareBetModal()), [dispatch]);

	const { shareHtmlAsImage } = useWebShareHtmlAsImage(cardRef, handleShareCompleted, handleShareError);

	const handleClose = useCallback(() => dispatch(closeShareBetModal()), [dispatch]);
	const handleShareClicked = useCallback(() => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		shareHtmlAsImage();
	}, [shareHtmlAsImage]);

	if (!isOpen || isLoadingTranslations) {
		return null;
	}

	return (
		<ShareBetModal
			translations={translations}
			isLoading={isLoading}
			bet={bet}
			cardRef={cardRef}
			onClose={handleClose}
			onShare={handleShareClicked}
		/>
	);
};
export default ShareBetModalContainer;
